import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import interact from 'interactjs'
import Slider from 'rc-slider'
import Store from 'store'
import request from 'superagent'
import 'rc-slider/assets/index.css'
import Uploader from './Uploader'
import './HandleEditor.css'
import env from '../config/env.json'
import params from '../config/params.json'

class HandleEditor extends Component {
  constructor (props) {
    super(props)

    this.loadedCounter = 0
    this.loadedAt = 2
    this.key = new Date().valueOf()

    this.canvas = {
      w: 827,
      h: 2067
    }

    this.state = {
      gotFile: false
    }

    this.coords = { x: 0, y: 0, w: 0, h: 0, rotation: 0, scale: 1 }

    this.checkLoaded = this.checkLoaded.bind(this)
    this.drawCanvas = this.drawCanvas.bind(this)

    this.uploadedFile = this.createLayer()
    this.alphaMask = this.createLayer()
    this.guidesMask = this.createLayer()
  }

  createLayer () {
    const img = new window.Image()
    img.onload = this.checkLoaded
    img.setAttribute('crossOrigin', 'anonymous')

    return img
  }

  checkLoaded () {
    this.loadedCounter++
    if (this.loadedCounter === this.loadedAt) {
      // create the invisible dragger (Boo Boo)
      interact('#editor')
        .draggable({
          inertia: true,
          onmove: this.dragImage.bind(this)
        })

      const x = (this.canvas.w / 2) - (this.uploadedFile.width / 2)
      const y = (this.canvas.h / 2) - (this.uploadedFile.height / 2)

      this.setImageCoords(x, y)
      this.setImageSize(this.uploadedFile.width, this.uploadedFile.height)
      this.drawCanvas()
    }
  }

  setImageCoords (x, y) {
    this.coords.x = x
    this.coords.y = y
  }

  setImageSize (w, h) {
    this.coords.w = w
    this.coords.h = h
  }

  setImageRotation (rotation) {
    this.coords.rotation = rotation
  }

  setScale (scale) {
    this.coords.scale = scale
  }

  dragImage (event) {
    const x = (this.coords.x * this.coords.scale) + event.dx
    const y = (this.coords.y * this.coords.scale) + event.dy

    this.setImageCoords(x / this.coords.scale, y / this.coords.scale)
    this.drawCanvas()
  }

  getImageCenter () {
    return {
      x: this.coords.x - (this.coords.w / 2),
      w: this.coords.y - (this.coords.h / 2)
    }
  }

  resizeImage (value) {
    const ratio = (value - 25) * 4 / 100

    this.setScale(ratio + 1)
    this.drawCanvas()
  }

  rotateImage (value) {
    const degrees = (value - 50) / 5 * 9

    this.setImageRotation(degrees)
    this.drawCanvas()
  }

  drawCheckeredBackground () { // WIP
    const editor = ReactDOM.findDOMNode(this.refs.editor)
    const ctx = editor.getContext('2d')

    // for (var i = 0; i < nRow; ++i) {
    //   for (var j = 0, col = nCol / 2; j < col; ++j) {
    //     ctx.rect(2 * j * w + (i % 2 ? 0 : w), i * h, w, h)
    //   }
    // }

    ctx.fill()
  }

  drawCanvas (toImage = false) {
    const editor = ReactDOM.findDOMNode(this.refs.editor)
    const ctx = editor.getContext('2d')
    // const radian = Math.PI / 180

    // Delete everything before drawing again
    ctx.clearRect(0, 0, this.canvas.w, this.canvas.h)

    ctx.save()

    // draw the mask
    ctx.globalCompositeOperation = 'source-over'
    if (!toImage) {
      ctx.beginPath()
      ctx.rect(0, 0, this.canvas.w, this.canvas.h)
      ctx.fillStyle = 'rgba(0, 0, 0, 0.2)'
      ctx.fill()
    }
    ctx.drawImage(this.alphaMask, 0, 0, this.canvas.w, this.canvas.h)

    // draw the uploaded file
    ctx.globalCompositeOperation = 'source-in'
    if (this.uploadedFile.src) {
      ctx.translate(this.canvas.w / 2, this.canvas.h / 2)
      ctx.scale(this.coords.scale, this.coords.scale)
      ctx.translate(this.canvas.w / 2 * -1, this.canvas.h / 2 * -1)
      ctx.drawImage(this.uploadedFile, this.coords.x, this.coords.y)
    } else {
      ctx.beginPath()
      ctx.rect(0, 0, this.canvas.w, this.canvas.h)
      ctx.fillStyle = 'rgb(200, 200, 200)'
      ctx.fill()
    }

    ctx.restore()

    if (toImage) {
      const customDesigns = Store.get('customDesigns') || []

      customDesigns.push({
        key: this.key,
        handle: this.props.handle,
        dataURL: editor.toDataURL(),
        originalFile: this.uploadedFile.src,
        coords: this.coords,
        canvas: this.canvas
      })

      Store.set('customDesigns', customDesigns)
    }

    // add guides
    ctx.globalCompositeOperation = 'source-over'
    ctx.drawImage(this.guidesMask, 0, 0, this.canvas.w, this.canvas.h)
  }

  onUpload (res) {
    this.loadedAt = 3
    this.uploadedFile.src = res
    this.setState({ gotFile: true })
  }

  getPerspectiveView (callback) {
    const req = request.post(this.props.perspHandler)
    const dataURL = Store.get('customDesigns')
      .find(d => d.key === this.key).dataURL

    req.set('Content-Type', 'application/json')
    req.set('Accept', 'application/json')
    req.send(JSON.stringify({
      model: this.props.handle,
      image: dataURL
    }))
    req.end((err, res) => {
      if (err) {
        console.error(err)
        this.setState({ success: false })
      }
      const response = JSON.parse(res.text)
      if (response.code === 200) {
        callback(response.data)
      }
    })
  }

  saveCanvas () {
    this.drawCanvas(true)

    const customDesigns = Store.get('customDesigns')
    const dataURL = customDesigns.find(d => d.key === this.key).dataURL

    this.getPerspectiveView(image => {
      // super @UGLY Doing the job 2 times... (here and in the Configurator)
      this.props.addColors(
        {
          image_file: this.props.handle + '/RAL/0011.png',
          color: 'black',
          color_css: '#000',
          color_type: 'custom',
          ornament: this.key,
          ornament_category: null,
          ornament_color: null,
          ornament_css: null,
          css: {
            backgroundColor: '#333',
            backgroundImage: 'url(\'' + dataURL + '\')',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          },
          declinable: false,
          customDesign: image.dataURL
        },
        {
          image_file: this.props.handle + '/RAL/0010.png',
          color: 'white',
          color_css: '#fff',
          color_type: 'custom',
          ornament: this.key,
          ornament_category: null,
          ornament_color: null,
          ornament_css: null,
          css: {
            backgroundColor: '#333',
            backgroundImage: 'url(\'' + dataURL + '\')',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          },
          declinable: false,
          customDesign: image.dataURL
        }
      )

      // Save this in the store
      customDesigns.find(d => d.key === this.key).dataURL = image.dataURL
      Store.set('customDesigns', customDesigns)

      // And close the editor
      this.props.close()
    })
  }

  componentDidMount () {
    const wrapper = ReactDOM.findDOMNode(this.refs.wrapper)

    if (wrapper !== null) {
      this.canvas.w = wrapper.clientHeight * 0.4
      this.canvas.h = wrapper.clientHeight

      // Then update actual canvas
      const editor = ReactDOM.findDOMNode(this.refs.editor)
      editor.width = this.canvas.w
      editor.height = this.canvas.h
    }

    this.alphaMask.src = require('../assets/images/handleAlphas/' + this.props.handle + '.png')
    this.guidesMask.src = require('../assets/images/handleAlphas/' + this.props.handle + '-guides.png')
    // @WARNING remove this thing (meant for dev purposes)
    // this.uploadedFile.src = 'https://i.imgur.com/TsSG637.jpg'
  }

  render () {
    return [
      <div className='configurator-overlay' onClick={this.props.close} key='editor-overlay' />,
      <div className='configurator-editor configurator-modal' ref='wrapper' key='editor-wrapper'>
        <div className='configurator-controls'>
          {
            !this.state.gotFile
            ? <Uploader
              className='configurator-red-button'
              uploadHandler={env.apiURL + params.uploadRoute}
              onUpload={this.onUpload.bind(this)}
            />
            : null
          }
          <button className='configurator-red-button' onClick={this.props.close}>
            <span className='material-icons'>close</span>
          </button>
        </div>
        {/* <Slider
          vertical
          defaultValue={50}
          onChange={this.rotateImage.bind(this)}
          disabled={!this.state.gotFile}
        /> */}
        <canvas
          id='editor'
          ref='editor'
          width={this.canvas.w}
          height={this.canvas.h}
        />
        <div className='editor-right-controls'>
          <span className='material-icons resize-icon'>transform</span>
          <Slider
            vertical
            defaultValue={25}
            onChange={this.resizeImage.bind(this)}
            disabled={!this.state.gotFile}
          />
        </div>
        {
          this.uploadedFile.src
          ? <button
            className='configurator-red-button configurator-save-button'
            onClick={this.saveCanvas.bind(this)}
          >Save</button>
          : null
        }
      </div>
    ]
  }
}

export default HandleEditor



// WEBPACK FOOTER //
// ./src/components/HandleEditor.js